import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workflow_trigger_cron",
  "use": "icon-workflow_trigger_cron-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-workflow_trigger_cron\">\n  <g>\n    <circle stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" cx=\"15\" cy=\"17\" r=\"11\" />\n    <path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M15 17h6M15 17v-6\" />\n    <rect x=\"8\" y=\"1\" width=\"14\" height=\"2\" rx=\"1\" />\n    <path d=\"M14 2h2v4h-2z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol